import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "mx-auto max-w-3xl p-2 text-left" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("p", { class: "mb-2" }, " Splatter is a fully on-chain generative art collection. Unlike most NFTs in the market, it dynamically generates images on the blockchain. Since it does not rely on either HTTP server or IPFT, it is fully decentralized and composable, and its availably is guaranteed by the blockchain itself. ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProviderView = _resolveComponent("ProviderView")!
  const _component_Mint = _resolveComponent("Mint")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_ProviderView, { assetProvider: "splatterArt" }),
    (_ctx.network != 'localhost')
      ? (_openBlock(), _createBlock(_component_Mint, {
          key: 0,
          network: _ctx.network,
          tokenGated: true,
          tokenAddress: _ctx.tokenAddress,
          tokenGateAddress: _ctx.tokenGateAddress
        }, null, 8, ["network", "tokenAddress", "tokenGateAddress"]))
      : _createCommentVNode("", true)
  ]))
}